// builder-components.ts
import { Builder } from '@builder.io/react';

import HeaderCallComponent from './header-call-component';

Builder.registerComponent(HeaderCallComponent, {
  name: 'HeaderCallComponent',
  noWrap: true,
});
